<template>
  <div :class="titleLayout" class="cms-text-page">
    <div v-if="doc.type !== 'cms-report'" class="container maxWidth-sm">
      <div style="height: 40px"></div>

      <button
        v-if="canGoBack"
        type="button"
        class="btn btn-primary-back button-with-icon-and-text hidden-print back-button"
        @click="back"
      >
        Back
      </button>
      <div class="title-container">
        <div class="title-text">
          <div v-html="titleHtml"></div>
          <hr class="hr-magazine hr-magazine-left hr-magazine-thick hr-magazine-short" />

          <h2 v-if="subtitle">{{ subtitle }}</h2>
          <div style="height: 20px"></div>
        </div>
        <div @mouseenter="triggerAnimation" @focusin="triggerAnimation">
          <CmsImg
            v-if="headerImageSrc"
            ref="headerImage"
            :src="headerImageSrc"
            class="title-image"
          />
        </div>
      </div>
      <div style="height: 10px"></div>
    </div>
    <CmsBody :cmsPage="developDoc" :context="context" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { CmsReport } from "../../services/cms/types/cms-report";
import {
  CmsDevelopPage,
  CmsDocument,
  CmsResource,
  CmsResourceData,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import CmsBody from "../../components/cms/cms-body.vue";
import CmsImg from "../../components/cms/cms-img.vue";
import SwipeNavigationInfo from "../../components/swipe-navigation-info";

const props = defineProps<{
  doc: CmsDocument;
  context?: Record<string, any>;
}>();

const doc = computed(() => props.doc as CmsResource | CmsReport | CmsDevelopPage);
const developDoc = computed(() => props.doc as CmsDevelopPage);

const lastType = ref<string | null>(null);
const lastUid = ref<string | null>(null);
const loadedDoc = ref<CmsDocument | null>(null);

const headerImageSrc = computed(() => {
  if (props.doc?.type === "cms-report") return "";

  const { title_image, title_image_animation } = props.doc?.data as CmsResourceData;
  return title_image_animation?.url ?? title_image;
});

const canGoBack = computed(() => !!document.referrer);
const title = computed(() => cms.asText((props.doc?.data as CmsResourceData)?.title));
const titleHtml = computed(() => cms.asHtml((props.doc?.data as CmsResourceData)?.title));
const subtitle = computed(() => cms.asText((props.doc?.data as CmsResourceData)?.subtitle));
const pageTheme = computed(() => (props.doc?.data as CmsResourceData)?.page_visual_theme);
const titleLayout = computed(() => (props.doc?.data as CmsResourceData)?.title_layout || "");

const headerImage = ref();

function triggerAnimation(): void {
  (headerImage.value as any).animate();
}

function back(): void {
  SwipeNavigationInfo.temporarilyDisable();
  window.history.back();
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import (reference) "../../styles/bootstrap/variables.less";

.cms-text-page {
  @media (hover: none) and (pointer: coarse) {
    .back-button {
      display: none;
    }
  }

  @media (min-width: @screen-md-min) {
    .back-button {
      position: absolute;
      margin-left: -130px;
      margin-top: 22px;
    }
  }

  //.bottom-title-image is the default
  .title-image {
    width: 100%;
    max-height: 40vh;
  }

  &.no-title-image {
    .title-image {
      display: none;
    }
  }

  &.right-title-image {
    .title-container {
      display: flex;
    }

    .title-image {
      width: 10rem;
      right: 35rem;
      margin-top: 2rem;
    }
  }
}
</style>
